













































import Component, {mixins} from "vue-class-component";
import AuthMixin from "../mixins/auth.mixin";
import {Emit, Ref, Prop} from "vue-property-decorator";
import {IUser, UserLevel, UserLevels} from "shared/entities/user";
import {UpdateUserRequest} from "shared/api/routes/user";
import {BModal} from "bootstrap-vue";
import {apiHandler} from "@/services/api-handler";
import {Api} from "shared/api";

@Component({})
export default class AddUser extends mixins(AuthMixin) {
    private editUserProps: UpdateUserRequest = {};
    editUserOriginal?: IUser;

    @Prop({required: true})
    owners!: IUser[];

    @Ref()
    private readonly editUserModel!: BModal;

    UserLevel = UserLevel

    get levels() {
        if (this.user?.level !== UserLevel.Admin)
            return UserLevels.filter(level => level < (this.user?.level ?? 0)).map(level => ({level, title: UserLevel[level]}));
        else
            return UserLevels.map(level => ({level, title: UserLevel[level]}));
    }

    @Emit("finished")
    private finished(user: IUser): IUser {
        this.editUserModel.hide();
        return user;
    }

    private async editUser() {
        if (this.editUserOriginal === undefined) return;
        const id = this.editUserOriginal.id;
        const toSend: UpdateUserRequest = {};
        if (this.editUserOriginal.firstName !== this.editUserProps.firstName) toSend.firstName = this.editUserProps.firstName;
        if (this.editUserOriginal.lastName !== this.editUserProps.lastName) toSend.lastName = this.editUserProps.lastName;
        if (this.editUserOriginal.email !== this.editUserProps.email) toSend.email = this.editUserProps.email;
        if (this.editUserOriginal.level !== this.editUserProps.level) toSend.level = this.editUserProps.level;
        if (this.editUserOriginal.owner?.id !== this.editUserProps.ownerId) toSend.ownerId = this.editUserProps.ownerId;

        const result = await apiHandler(() => Api.user[id].Patch(toSend));
        if (result.valid) this.finished(result.user);
        else alert(result.error);
        alert("User Updated");
        this.editUserOriginal = undefined;
        this.editUserProps = {};
    }

    public show(user: IUser) {
        this.editUserProps = {firstName: user.firstName, lastName: user.lastName, email: user.email, level: user.level};
        this.editUserOriginal = {id: user.id, firstName: user.firstName, lastName: user.lastName, email: user.email, level: user.level, owner: user.owner};
        this.editUserModel.show();
    }
}
